import { ZendeskHelpCenterUrlList } from './ZendeskHelpCenterUrlList';
import type { Control, UseFormClearErrors } from 'react-hook-form';
import type { ZendeskHelpCenterFormValues } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/zendeskHelpCenterFormValues';

export const ZendeskHelpCenterExcludedUrls = ({
  control,
  clearErrors = () => {},
}: {
  control: Control<ZendeskHelpCenterFormValues>;
  clearErrors?: UseFormClearErrors<ZendeskHelpCenterFormValues>;
}) => (
  <ZendeskHelpCenterUrlList
    control={control}
    clearErrors={clearErrors}
    name={'excluded_articles'}
    title={'Excluded URLs'}
    itemLabel={'excluded URL'}
    addLabel={'Exclude specific article'}
  />
);
